/**
 * ProductionMonitoringPage - Production system monitoring dashboard
 *
 * Surfaces the ProductionMonitoringDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides real-time visibility into production system health, performance, and incidents.
 *
 * Route: /admin/production-monitoring
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconActivityHeartbeat } from '@tabler/icons-react';

import { ProductionMonitoringDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function ProductionMonitoringPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="cyan">
            <IconActivityHeartbeat size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Production Monitoring</Title>
            <Text size="sm" c="dimmed">
              Real-time production system health, performance, and incident tracking
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ProductionMonitoringDashboard />
    </Container>
  );
}

export default ProductionMonitoringPage;
